import {Options} from "@material-table/core";
import {QuotationAttachmentSchema} from "@feature/quotations";

export const ACCEPTED_FORMATS = [
  "image/*",
  "application/pdf",
  ".xls",
  ".xlsx",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
];
export const MAX_SIZE = 5120000;  // 5MB

export const OPTIONS: Options<QuotationAttachmentSchema> = {
  filtering: false,
  search: false,
  sorting: true,
  pageSize: 5,
  filterCellStyle: { maxWidth: 250 },
  headerStyle: { whiteSpace: "nowrap", fontWeight: "bold" },
  // @ts-ignore
  cellStyle: { padding: 0, textTransform: "uppercase" },
};